var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_1164_2533)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1164_2533",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1164_2533",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1164_2533",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABQklEQVR4nO2SMUvDUBDHY8VBEWd18RO4WAe36l3AigVFyGK9izhkcPEjxNHV0dXBRVzEz+AiOjtKa3FxqIODqPylL+TRklTTRtAhB3/C4+79f3e55zhF/JuAcA1CLSgjl4Ra8N31JEDpIre5Wl0mAY4zAmWF0nOO7ttQOoDnjSYB9eqU+fqVaQifDW7O59hzZ42HV5lM28FTZwJ79nkZyvcZjB8h7lbPLpUfUnZgx7zC9spc1MnSOIQPofSWYv4OoeO4W9RXZ6B8Guf7AyLIqzEOymMmt+vOQ+m6q+YW4i6aXBiW4HMApZduj+8BVnTXYyS8bxSGpahrWoDSTdrdjADuTPMJoZP4EZjaoDYB4SMoffS7lx2gVk3s0CaENyDU+Kl+GAAGUQHAML+o+Ws7EGqkAGgty+tABnP4XE0Aiviz+AKp1f9gDNUhFAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.dc7290d7a8dc11dc32857ecc443392f9.svg";
export { ForwardRef as ReactComponent };